import {
  CanvasModule,
  CanvasModuleType,
  PdfItemType,
} from "@pdf-tools/four-heights-pdf-web-viewer";
import { AnnotationService } from "../annotation.service";
import { imageDataUrlToUint8Array } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Tools';
import { firstValueFrom } from "rxjs";


export class CustomAddCameraImageAnnotationModule extends CanvasModule {
  public toolbarElement: HTMLElement | null = null;
  private activated = false;

  static moduleInfo = {
    name: "CustomAddCameraIMageAnnotationModule",
    moduleType: CanvasModuleType.Tool,
    requiredFeatures: {
      annotate: true,
      fillFormFields: false,
    },
    translationKey: "Photo",
    icon: {
      width: 16,
      height: 16,
      path: 'M10.707 3H14.5l.5.5v9l-.5.5h-13l-.5-.5v-9l.5-.5h3.793l.853-.854L6.5 2h3l.354.146zM2 12h12V4h-3.5l-.354-.146L9.293 3H6.707l-.853.854L5.5 4H2zm1.5-7a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M8 6a2 2 0 1 1 0 4a2 2 0 0 1 0-4m0-1a3 3 0 1 0 0 6a3 3 0 0 0 0-6',
  } as any as string
    //icon: "image",
  };
  annotationService: AnnotationService | undefined;

  constructor() {
    super();
    this.toolbarElement = null;
    this.name = CustomAddCameraImageAnnotationModule.moduleInfo.name;
    this.activate = this.activate.bind(this);
    this.annotationService = globalThis.__liveDokWeb__.annotationService;
  }


    public onRegister(): { toolbar: HTMLElement | undefined}  {
      this.toolbarElement = document.createElement("div");
    return {
      toolbar: this.toolbarElement ? this.toolbarElement : undefined,
    };
  }


  public async activate() {

    if(!this.annotationService) {
      return;
    }
    if (this.toolbarElement == null) {
      return;
    }

    const photo = await firstValueFrom(this.annotationService.captureWebcamImage());

    if(!photo) {
      return;
    }

    const imageInfo = {
      width: photo.width,
      height: photo.height,
      stampImage: imageDataUrlToUint8Array(photo.data),
    };
    this.createPhotoAnnotation(imageInfo);


  }

  createPhotoAnnotation(imageInfo: any) {
    if (this.pdfApi !== null && this.store !== null && this.options !== null) {
      const state = this.store.getState();
      const canvasRect = this.getCanvasSize();
       // get page to insert image
      let page = this.pdfApi.getPageNumber();
      const screenRect = {
        x: 0,
        y: 0,
        w: canvasRect.width,
        h: canvasRect.height,
      };
      const pageScreenRect = this.pdfApi.getPageScreenRect(page);
      const x1 = Math.max(screenRect.x, pageScreenRect.x);
      const y1 = Math.max(screenRect.y, pageScreenRect.y);
      const x2 = Math.min(screenRect.w, pageScreenRect.x + pageScreenRect.w);
      const y2 = Math.min(screenRect.h, pageScreenRect.y + pageScreenRect.h);
      const boundingRect = {
        x: x1,
        y: y1,
        w: x2 - x1,
        h: y2 - y1,
      };
      const pageBoundingBox = this.pdfApi.transformScreenRectToPdfRect(boundingRect, page);
      const imagepPdfRect = {
        pdfX: 0,
        pdfY: 0,
        pdfW: imageInfo.width,
        pdfH: imageInfo.height,
        page,
      };
      if (imagepPdfRect.pdfW > pageBoundingBox.pdfW) {
        const f = (pageBoundingBox.pdfW / imagepPdfRect.pdfW) * 0.97;
        imagepPdfRect.pdfW = imagepPdfRect.pdfW * f;
        imagepPdfRect.pdfH = imagepPdfRect.pdfH * f;
      }
      if (imagepPdfRect.pdfH > pageBoundingBox.pdfH) {
        const f = (pageBoundingBox.pdfH / imagepPdfRect.pdfH) * 0.97;
        imagepPdfRect.pdfW = imagepPdfRect.pdfW * f;
        imagepPdfRect.pdfH = imagepPdfRect.pdfH * f;
      }
      imagepPdfRect.pdfX = (pageBoundingBox.pdfW - imagepPdfRect.pdfW) / 2 + pageBoundingBox.pdfX;
      imagepPdfRect.pdfY = (pageBoundingBox.pdfH - imagepPdfRect.pdfH) / 2 + pageBoundingBox.pdfY;
      this.pdfApi.registerStampImage(imageInfo.stampImage).then((imageId) => {
        if (this.pdfApi !== null && this.options !== null) {
          const annotation = {
            itemType: PdfItemType.STAMP,
            imageId,
            page,
            color: this.options.annotation.colors.defaultHighlightColor,
            pdfRect: imagepPdfRect,
            author: this.options.viewer.general.user,
          };
          this.pdfApi
            .createItem(annotation)
            .then((annot) => {
              // select new annotation
              const pdfViewerCanvasApi = this.pdfViewerCanvas;
              // @ts-ignore
              pdfViewerCanvasApi.dispatchEvent('itemSelected', annot);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    }
  }

}

